export default "__VITE_PUBLIC_ASSET__9979e5ba__"